import ProfailPage from "./profail/ProfailPage";
export default ProfailPage;
